import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { postData } from '../../Api';
import {
    MobileInfoBox,
    Modal,
    PanelBox,
    TextView,
    Title
} from '../../components/Display';
import {
    Button,
    DataForm,
    MultiSelectBox,
    SearchBox,
    SearchDateBox,
} from '../../components/Form';
import {
    Grid,
    GridColumn,
    LeftComponents,
    RightComponents,
    Row,
} from '../../components/Layout';
import {
    TableBody,
    TableColumn,
    TableData,
    TableHeader,
    TableRow,
} from '../../components/Table';
import TaroffOrdersDelete from '../orders/TaroffOrdersDelete';
import TaroffOrdersEdit from '../orders/TaroffOrdersEdit';
import TaroffOrdersView from '../orders/TaroffOrdersView';
import TaroffOrdersPeikSetDelivered from '../peik/TaroffOrdersPeikSetDelivered';
import TaroffOrdersPeikSetInit from '../peik/TaroffOrdersPeikSetInit';
import TaroffOrdersPeikSetNotAccepted from '../peik/TaroffOrdersPeikSetNotAccepted';
import TaroffOrdersPeikSetRejected from '../peik/TaroffOrdersPeikSetRejected';

export default function TaroffOrdersPeikSent(props) {
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const [modal, setModal] = useState(null);
    const allProps = { ...props, ...Object.fromEntries(searchParams.entries()) };
    const handleCancelDelivered = () => {
        console.log('handlecomp2');
    };
    const handleConfirmDelivered = () => {
        console.log('handlecomp3');
    };
    const handleShowDeliveredDialog = () => {
        const childDialog = (
            <>
                <DataForm>
                    <Title>تحویل شده</Title>
                    <Grid>
                        <GridColumn width={12}>
                            <TextView>
                                همه سفارشات انتخاب شده به وضعیت تحویل شده تغییر کنند ؟
                            </TextView>
                        </GridColumn>
                    </Grid>
                    <LeftComponents>
                        <Button onClick={handleCancelDelivered}>انصراف</Button>
                        <Button onClick={handleConfirmDelivered}>ذخیره</Button>
                    </LeftComponents>
                </DataForm>
            </>
        );
        setModal(
            Modal({
                children: childDialog,
                onDismiss: () => setModal(null),
            })
        );
        console.log('child-dialog');
    };
    const [formQShopIdOptions, setFormQShopIdOptions] = useState([]);
    useEffect(() => {
        postData('/api/panel/page/taroff-orders-peik-sent/select-data/q-shop-id').then(
            (response) => {
                setFormQShopIdOptions(response.data);
            }
        );
    }, []);
    const [formQZoneIdOptions, setFormQZoneIdOptions] = useState([]);
    useEffect(() => {
        postData('/api/panel/page/taroff-orders-peik-sent/select-data/q-zone-id').then(
            (response) => {
                setFormQZoneIdOptions(response.data);
            }
        );
    }, []);
    const [formQPeikIdOptions, setFormQPeikIdOptions] = useState([]);
    useEffect(() => {
        postData('/api/panel/page/taroff-orders-peik-sent/select-data/q-peik-id').then(
            (response) => {
                setFormQPeikIdOptions(response.data);
            }
        );
    }, []);
    const [formQShiftIdOptions, setFormQShiftIdOptions] = useState([]);
    useEffect(() => {
        postData('/api/panel/page/taroff-orders-peik-sent/select-data/q-shift-id').then(
            (response) => {
                setFormQShiftIdOptions(response.data);
            }
        );
    }, []);
    const [formQDeliverTimeIdOptions, setFormQDeliverTimeIdOptions] = useState([]);
    useEffect(() => {
        postData('/api/panel/page/taroff-orders-peik-sent/select-data/q-deliver-time-id').then(
            (response) => {
                setFormQDeliverTimeIdOptions(response.data);
            }
        );
    }, []);
    const handleSearch = () => {
        applyFilters();
    };
    const [tableData, setTableData] = useState({});
    const [tableSize, setTableSize] = useState(parseInt(allProps['size']) || 20);
    const [tablePage, setTablePage] = useState(parseInt(allProps['page']) || 1);
    const gotoPage = (page, size = undefined) => {
        setTableData({});
        setTablePage(page);
        size && setTableSize(size);
        setSearchParams({ ...searchParams, page: page, size: size || tableSize });
    };
    const clearFilters = () => {
        setFilterQId('');
        setFilterQShopId('');
        setFilterQZoneId('');
        setFilterQPeikId('');
        setFilterQTitle('');
        setFilterQInsertTimeFrom('');
        setFilterQInsertTimeTo('');
        setFilterQReadyTimeFrom('');
        setFilterQReadyTimeTo('');
        setFilterQShiftId('');
        setFilterQDeliverTimeId('');
        setFilterQCustomerName('');
        setFilterQCustomerMobile('');
        setFilterQAddress('');
        setFilterQPostBarcode('');
        setFilterQShopCodeIn('');
        setSearchParams({});
    };
    const applyFilters = () => {
        const newSearchParams = {};
        filterQId && (newSearchParams['q-id'] = filterQId);
        filterQShopId && (newSearchParams['q-shop-id'] = filterQShopId);
        filterQZoneId && (newSearchParams['q-zone-id'] = filterQZoneId);
        filterQPeikId && (newSearchParams['q-peik-id'] = filterQPeikId);
        filterQTitle && (newSearchParams['q-title'] = filterQTitle);
        filterQInsertTimeFrom && (newSearchParams['q-insert-time-from'] = filterQInsertTimeFrom);
        filterQInsertTimeTo && (newSearchParams['q-insert-time-to'] = filterQInsertTimeTo);
        filterQReadyTimeFrom && (newSearchParams['q-ready-time-from'] = filterQReadyTimeFrom);
        filterQReadyTimeTo && (newSearchParams['q-ready-time-to'] = filterQReadyTimeTo);
        filterQShiftId && (newSearchParams['q-shift-id'] = filterQShiftId);
        filterQDeliverTimeId && (newSearchParams['q-deliver-time-id'] = filterQDeliverTimeId);
        filterQCustomerName && (newSearchParams['q-customer-name'] = filterQCustomerName);
        filterQCustomerMobile && (newSearchParams['q-customer-mobile'] = filterQCustomerMobile);
        filterQAddress && (newSearchParams['q-address'] = filterQAddress);
        filterQPostBarcode && (newSearchParams['q-post-barcode'] = filterQPostBarcode);
        filterQShopCodeIn && (newSearchParams['q-shop-code-in'] = filterQShopCodeIn);
        navigate({ search: '?' + new URLSearchParams(newSearchParams).toString() });
    };
    const [filterQId, setFilterQId] = useState(allProps['q-id'] || '');
    const [filterQShopId, setFilterQShopId] = useState(allProps['q-shop-id'] || '');
    const [filterQZoneId, setFilterQZoneId] = useState(allProps['q-zone-id'] || '');
    const [filterQPeikId, setFilterQPeikId] = useState(allProps['q-peik-id'] || '');
    const [filterQTitle, setFilterQTitle] = useState(allProps['q-title'] || '');
    const [filterQInsertTimeFrom, setFilterQInsertTimeFrom] = useState(
        allProps['q-insert-time-from'] || ''
    );
    const [filterQInsertTimeTo, setFilterQInsertTimeTo] = useState(
        allProps['q-insert-time-to'] || ''
    );
    const [filterQReadyTimeFrom, setFilterQReadyTimeFrom] = useState(
        allProps['q-ready-time-from'] || ''
    );
    const [filterQReadyTimeTo, setFilterQReadyTimeTo] = useState(allProps['q-ready-time-to'] || '');
    const [filterQShiftId, setFilterQShiftId] = useState(allProps['q-shift-id'] || '');
    const [filterQDeliverTimeId, setFilterQDeliverTimeId] = useState(
        allProps['q-deliver-time-id'] || ''
    );
    const [filterQCustomerName, setFilterQCustomerName] = useState(
        allProps['q-customer-name'] || ''
    );
    const [filterQCustomerMobile, setFilterQCustomerMobile] = useState(
        allProps['q-customer-mobile'] || ''
    );
    const [filterQAddress, setFilterQAddress] = useState(allProps['q-address'] || '');
    const [filterQPostBarcode, setFilterQPostBarcode] = useState(allProps['q-post-barcode'] || '');
    const [filterQShopCodeIn, setFilterQShopCodeIn] = useState(allProps['q-shop-code-in'] || '');
    useEffect(() => {
        postData('/api/panel/page/taroff-orders-peik-sent/table-data', {
            size: tableSize,
            page: tablePage,
            q_id: filterQId,
            q_shop_id: filterQShopId,
            q_zone_id: filterQZoneId,
            q_peik_id: filterQPeikId,
            q_title: filterQTitle,
            q_insert_time_from: filterQInsertTimeFrom,
            q_insert_time_to: filterQInsertTimeTo,
            q_ready_time_from: filterQReadyTimeFrom,
            q_ready_time_to: filterQReadyTimeTo,
            q_shift_id: filterQShiftId,
            q_deliver_time_id: filterQDeliverTimeId,
            q_customer_name: filterQCustomerName,
            q_customer_mobile: filterQCustomerMobile,
            q_address: filterQAddress,
            q_post_barcode: filterQPostBarcode,
            q_shop_code_in: filterQShopCodeIn,
        }).then((response) => {
            setTableData(response.data);
        });
    }, [searchParams, modal, props]);
    const handleSetOrderRejected = (row) => {
        setModal(
            Modal({
                children: (
                    <TaroffOrdersPeikSetRejected
                        taroff-orders-id={row.param_id}
                        onDismiss={() => setModal(null)}
                    />
                ),
                onDismiss: () => setModal(null),
            })
        );
    };
    const handleSetOrderDelivered = (row) => {
        setModal(
            Modal({
                children: (
                    <TaroffOrdersPeikSetDelivered
                        taroff-orders-id={row.param_id_2}
                        onDismiss={() => setModal(null)}
                    />
                ),
                onDismiss: () => setModal(null),
            })
        );
    };
    const handleViewOrder = (row) => {
        setModal(
            Modal({
                children: (
                    <TaroffOrdersView
                        taroff-orders-id={row.param_id_3}
                        onDismiss={() => setModal(null)}
                    />
                ),
                onDismiss: () => setModal(null),
            })
        );
    };
    const handleEditOrder = (row) => {
        setModal(
            Modal({
                children: (
                    <TaroffOrdersEdit
                        taroff-orders-id={row.param_id_4}
                        onDismiss={() => setModal(null)}
                    />
                ),
                onDismiss: () => setModal(null),
            })
        );
    };
    const handleDeleteOrder = (row) => {
        setModal(
            Modal({
                children: (
                    <TaroffOrdersDelete
                        taroff-orders-id={row.param_id_5}
                        onDismiss={() => setModal(null)}
                    />
                ),
                onDismiss: () => setModal(null),
            })
        );
    };
    const handleSetPeikNotAccepted = (row) => {
        setModal(
            Modal({
                children: (
                    <TaroffOrdersPeikSetNotAccepted
                        taroff-orders-id={row.param_id_6}
                        onDismiss={() => setModal(null)}
                    />
                ),
                onDismiss: () => setModal(null),
            })
        );
    };
    const handleSetOrderInit = (row) => {
        setModal(
            Modal({
                children: (
                    <TaroffOrdersPeikSetInit
                        taroff-orders-id={row.param_id_7}
                        onDismiss={() => setModal(null)}
                    />
                ),
                onDismiss: () => setModal(null),
            })
        );
    };
    return (
        <PanelBox>
            <Row>
                <RightComponents>
                    <Title>سفارشات ارسال شده</Title>
                </RightComponents>
                <LeftComponents>
                    <Button onClick={handleShowDeliveredDialog} color={'secondary'}>
                        تحویل شد
                    </Button>
                </LeftComponents>
            </Row>
            <SearchBox onEnter={applyFilters} label={'شناسه'} value={filterQId} onChange={setFilterQId} width={'120px'} />
            <MultiSelectBox
                label={'فروشگاه'}
                options={formQShopIdOptions}
                value={filterQShopId}
                onChange={setFilterQShopId}
            />
            <MultiSelectBox
                label={'محدوده'}
                options={formQZoneIdOptions}
                value={filterQZoneId}
                onChange={setFilterQZoneId}
            />
            <MultiSelectBox
                label={'پیک'}
                options={formQPeikIdOptions}
                value={filterQPeikId}
                onChange={setFilterQPeikId}
            />
            <SearchBox onEnter={applyFilters}
                label={'عنوان'}
                value={filterQTitle}
                onChange={setFilterQTitle}
                width={'120px'}
            />
            <SearchDateBox onEnter={applyFilters}
                label={'زمان درج از'}
                value={filterQInsertTimeFrom}
                onChange={setFilterQInsertTimeFrom}
                width={'100px'}
            />
            <SearchDateBox onEnter={applyFilters}
                label={'زمان درج تا'}
                value={filterQInsertTimeTo}
                onChange={setFilterQInsertTimeTo}
                width={'100px'}
            />
            <SearchDateBox onEnter={applyFilters}
                label={'زمان آماده ارسال از'}
                value={filterQReadyTimeFrom}
                onChange={setFilterQReadyTimeFrom}
                width={'100px'}
            />
            <SearchDateBox onEnter={applyFilters}
                label={'زمان آماده ارسال تا'}
                value={filterQReadyTimeTo}
                onChange={setFilterQReadyTimeTo}
                width={'100px'}
            />
            <MultiSelectBox
                label={'شیفت های پیک تعارف'}
                options={formQShiftIdOptions}
                value={filterQShiftId}
                onChange={setFilterQShiftId}
            />
            <MultiSelectBox
                label={'زمان ارسال'}
                options={formQDeliverTimeIdOptions}
                value={filterQDeliverTimeId}
                onChange={setFilterQDeliverTimeId}
            />
            <SearchBox onEnter={applyFilters}
                label={'نام خریدار'}
                value={filterQCustomerName}
                onChange={setFilterQCustomerName}
                width={'120px'}
            />
            <SearchBox onEnter={applyFilters}
                label={'همراه خریدار'}
                value={filterQCustomerMobile}
                onChange={setFilterQCustomerMobile}
                width={'120px'}
            />
            <SearchBox onEnter={applyFilters}
                label={'آدرس'}
                value={filterQAddress}
                onChange={setFilterQAddress}
                width={'120px'}
            />
            <SearchBox onEnter={applyFilters}
                label={'بارکد پستی'}
                value={filterQPostBarcode}
                onChange={setFilterQPostBarcode}
                width={'120px'}
            />
            <Button onClick={handleSearch} color={'secondary'}>
                جستجو
            </Button>
            <SearchBox onEnter={applyFilters}Chips
                label={'کد رهگیری در فروشگاه'}
                value={filterQShopCodeIn}
                onChange={setFilterQShopCodeIn}
            />
            <RightComponents wrap={true}>
                <Button rightIcon={'far fa-search'} onClick={applyFilters}>
                    جستجو
                </Button>
                <Button rightIcon={'far fa-trash'} onClick={clearFilters}>
                    پاک کردن
                </Button>
            </RightComponents>
            <TableData total={tableData.total} size={tableSize} page={tablePage} setPage={gotoPage}>
                <TableHeader>
                    <TableRow>
                        <TableColumn mobile={true}>mobile</TableColumn>
                        <TableColumn mobile={false}>ردیف</TableColumn>
                        <TableColumn mobile={false}>عنوان</TableColumn>
                        <TableColumn mobile={false}>آدرس سفارش</TableColumn>
                        <TableColumn mobile={false}>عنوان محدوده سفارش</TableColumn>
                        <TableColumn mobile={false}>عنوان پیک سفارش</TableColumn>
                        <TableColumn mobile={false}>مبلغ سفارش</TableColumn>
                        <TableColumn mobile={false}>زمان درج سفارش</TableColumn>
                        <TableColumn mobile={false}>ویرایش</TableColumn>
                    </TableRow>
                </TableHeader>
                <TableBody>
                    {tableData.rows?.map((row, index) => (
                        <TableRow key={index}>
                            <TableColumn mobile={true}>
                                <MobileInfoBox />
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView>{row.text_id}</TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView bold={true}>{row.text_shop_id_title}</TextView>
                                <RightComponents>
                                    <TextView>{row.text_title}</TextView>
                                    <TextView>{row.text}</TextView>
                                    <TextView>{row.text_shop_code}</TextView>
                                </RightComponents>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <RightComponents>
                                    <TextView>{row.text_address}</TextView>
                                    <TextView>{row.text_2}</TextView>
                                    <TextView>{row.text_deliver_time_id_title}</TextView>
                                </RightComponents>
                                <TextView>{row.text_customer_name}</TextView>
                                <TextView>{row.text_op_time_state}</TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView>{row.text_zone_id_title}</TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView>{row.text_peik_id_title}</TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView format={'money'}>{row.text_payable_price}</TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView format={'persian-date-normal'}>
                                    {row.text_insert_time}
                                </TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <LeftComponents>
                                    <Button
                                        onClick={() => handleSetOrderRejected(row)}
                                        color={'warn'}
                                        rightIcon={'fal fa-times'}
                                        tooltip={'برگشتی'}
                                    ></Button>
                                    <Button
                                        onClick={() => handleSetOrderDelivered(row)}
                                        rightIcon={'far fa-check'}
                                        tooltip={'تحویل شده'}
                                    ></Button>
                                    <Button
                                        onClick={() => handleViewOrder(row)}
                                        rightIcon={'far fa-info'}
                                        tooltip={'مشاهده'}
                                    ></Button>
                                    <Button
                                        onClick={() => handleEditOrder(row)}
                                        rightIcon={'far fa-edit'}
                                        tooltip={'ویرایش'}
                                    ></Button>
                                    <Button
                                        onClick={() => handleDeleteOrder(row)}
                                        color={'warn'}
                                        rightIcon={'far fa-trash'}
                                        tooltip={'حذف'}
                                    ></Button>
                                    <Button
                                        onClick={() => handleSetPeikNotAccepted(row)}
                                        rightIcon={'fal fa-ban'}
                                        tooltip={'عدم قبول پیک'}
                                    ></Button>
                                    <Button
                                        onClick={() => handleSetOrderInit(row)}
                                        rightIcon={'fal fa-undo'}
                                        tooltip={'در انتظار تایید'}
                                    ></Button>
                                </LeftComponents>
                            </TableColumn>
                        </TableRow>
                    ))}
                </TableBody>
            </TableData>
            {modal && modal}
        </PanelBox>
    );
}
